import React, { useContext } from 'react';
import { Box, Divider, Icon, IconButton, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { AlertMessage } from '@eposnow/ui-core';
import { UIContext } from '../../context/UIContext';
import { UserContext } from '../../context/UserContext';

const CreateEditCard = ({
  resetObject,
  errorMessage,
  setErrorMessage,
  mode,
  translationKey,
  children,
}: {
  resetObject: () => void;
  errorMessage: string;
  setErrorMessage: (message: string) => void;
  mode: string;
  translationKey: string;
  children: JSX.Element;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { iOS } = useContext(UIContext);
  const { locale } = useContext(UserContext);

  return (
    <Box
      component="div"
      sx={{
        overflow: 'auto',
        ...(!iOS && {
          marginBottom: '65px',
        }),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingLeft: '10px',
          paddingTop: '4px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Icon sx={{ color: 'text.secondary', marginRight: 1 }}>
            {mode === 'create' ? <AddIcon /> : <EditOutlinedIcon />}
          </Icon>
          <Typography variant="h2">
            {t(`screens.${translationKey}.${mode === 'create' ? 'add' : 'edit'}`)}
          </Typography>
        </Box>
        <IconButton
          title={t('actions.close')}
          aria-label={t('actions.close')}
          color="inherit"
          size="small"
          onClick={resetObject}
          sx={{ padding: '12px' }}
        >
          <CloseIcon
            sx={{
              color: 'text.secondary',
            }}
          />
        </IconButton>
      </Box>
      <Divider
        sx={{
          marginTop: '4px',
        }}
      />

      {errorMessage && (
        <AlertMessage type="error" styles={{ margin: 2 }} action={() => setErrorMessage('')} locale={locale} theme={theme}>
          {errorMessage}
        </AlertMessage>
      )}
      {children}
    </Box>
  );
};

export default CreateEditCard;
